import BaseEntity from "../BaseEntity";
export default class EmptyCommitSimple extends BaseEntity {
}
